"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
var Token;
(function (Token) {
    Token[Token["Quote"] = 0] = "Quote";
    Token[Token["Dot"] = 1] = "Dot";
    Token[Token["At"] = 2] = "At";
    Token[Token["Backslash"] = 3] = "Backslash";
    Token[Token["Alpha"] = 4] = "Alpha";
    Token[Token["Numeral"] = 5] = "Numeral";
    Token[Token["Hyphen"] = 6] = "Hyphen";
    Token[Token["OtherPrintable"] = 7] = "OtherPrintable";
    Token[Token["Escapable"] = 8] = "Escapable";
    Token[Token["LeftSquareBracket"] = 9] = "LeftSquareBracket";
    Token[Token["RightSquareBracket"] = 10] = "RightSquareBracket";
    Token[Token["Invalid"] = 11] = "Invalid";
    Token[Token["EOF"] = 12] = "EOF";
})(Token || (exports.Token = Token = {}));
//# sourceMappingURL=token.js.map